import type { ReactNode } from 'react'
import { SaveStateContext, type SaveStateContextValue } from './SaveStateContextDef'

interface SaveStateProviderProps {
  children: ReactNode
  value: SaveStateContextValue
}

/**
 * Provider that makes save state available to children.
 *
 * The save state is computed in MindMapFlow and passed to this provider.
 * This allows components like MindMapHeader to access save state via context
 * instead of props.
 */
export function SaveStateProvider({ children, value }: SaveStateProviderProps) {
  return <SaveStateContext.Provider value={value}>{children}</SaveStateContext.Provider>
}
